import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
} from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LockIcon from '@mui/icons-material/Lock';

export default function SecurityCallout() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            bgcolor: 'primary.dark',
            color: 'white',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            align="center"
            gutterBottom
            sx={{ fontWeight: 700, mb: 4 }}
          >
            Security & Compliance
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <SecurityIcon sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  JWT Authentication
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Secure authentication with JSON Web Tokens in your application.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <LockIcon sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  Organization Isolation
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Complete data isolation between organizations for privacy and security.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <VerifiedUserIcon sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  SSO Roadmap
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Single Sign-On integration coming soon for enterprise customers.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Typography
            variant="body2"
            align="center"
            sx={{ mt: 4, opacity: 0.8 }}
          >
            Calendar sync works without admin consent. Your data is stored securely with
            configurable retention policies.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
